// extracted by mini-css-extract-plugin
export default {"button":"uk-z","reviewSort":"vk-z"};